export default [
  {
    id: 1,
    photo: "https://vetra.laborasyon.com/assets/images/products/1.jpg",
    name: "Headphone",
    shortDescription:
      "Lorem ipsum, dolor sit amet consectetur adipisicing elit.",
    featureDescription:
      "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Laboriosam dolor sit amet consectetur adipisicing elit., eaque. Porro dolorem asperiores eos nostrum corrupti! Sit officia distinctio quidem amet nulla",
    londDescription:
      "Lorem, ipsum dolor sit amet consectetur adipisicing elit. Maiores ad saepe porro laudantium, assumenda eos perspiciatis. Quia repellendus\n\n eligendi exercitationem explicabo consectetur facilis vitae nemo dignissimos, totam quas in nostrum optio blanditiis amet quam consequatur illum eos minus voluptates possimus aperiam non modi voluptatem velit!\n Doloremque distinctio commodi corporis adipisci voluptatem fugit maxime error officiis dicta deleniti exercitationem provident a obcaecati, quaerat dolores dolor harum non perferendis blanditiis ipsum aliquam\n\n ducimus sapiente molestias. Atque odio inventore consequuntur delectus beatae fugit. Accusamus, aut tempora cupiditate temporibus consequuntur dolorem iusto laborum nihil!",
    price: "$120.00",
    qty: 120,
    rating: 5.0,
    reviews: [
      {
        username: "Rodger Stutely",
        avatar_url: "https://i.pravatar.cc/150?img=69",
        review:
          "I love your products. It is very easy and fun to use this panel. I would recommend it to everyone.",
        rate: 5.0,
      },
      {
        username: "Corly Hailston",
        avatar_url: "https://i.pravatar.cc/150?img=25",
        review:
          "I love your products. It is very easy and fun to use this panel. I would recommend it to everyone.",
        rate: 5.0,
      },
      {
        username: "Hurleigh Smallcomb",
        avatar_url: "https://i.pravatar.cc/150?img=41",
        review:
          "I love your products. It is very easy and fun to use this panel. I would recommend it to everyone.",
        rate: 5.0,
      },
    ],
  },
  {
    id: 2,
    photo: "https://vetra.laborasyon.com/assets/images/products/2.jpg",
    name: "Shoe",
    shortDescription:
      "Lorem ipsum, dolor sit amet consectetur adipisicing elit.",
    featureDescription:
      "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Laboriosam dolor sit amet consectetur adipisicing elit., eaque. Porro dolorem asperiores eos nostrum corrupti! Sit officia distinctio quidem amet nulla",
    londDescription:
      "Lorem, ipsum dolor sit amet consectetur adipisicing elit. Maiores ad saepe porro laudantium, assumenda eos perspiciatis. Quia repellendus\n\n eligendi exercitationem explicabo consectetur facilis vitae nemo dignissimos, totam quas in nostrum optio blanditiis amet quam consequatur illum eos minus voluptates possimus aperiam non modi voluptatem velit!\n Doloremque distinctio commodi corporis adipisci voluptatem fugit maxime error officiis dicta deleniti exercitationem provident a obcaecati, quaerat dolores dolor harum non perferendis blanditiis ipsum aliquam\n\n ducimus sapiente molestias. Atque odio inventore consequuntur delectus beatae fugit. Accusamus, aut tempora cupiditate temporibus consequuntur dolorem iusto laborum nihil!",
    price: "$320.00",
    qty: 54,
    rating: 5,
    reviews: [
      {
        username: "Rodger Stutely",
        avatar_url: "https://i.pravatar.cc/150?img=69",
        review:
          "I love your products. It is very easy and fun to use this panel. I would recommend it to everyone.",
        rate: 5.0,
      },
      {
        username: "Corly Hailston",
        avatar_url: "https://i.pravatar.cc/150?img=25",
        review:
          "I love your products. It is very easy and fun to use this panel. I would recommend it to everyone.",
        rate: 5.0,
      },
      {
        username: "Hurleigh Smallcomb",
        avatar_url: "https://i.pravatar.cc/150?img=41",
        review:
          "I love your products. It is very easy and fun to use this panel. I would recommend it to everyone.",
        rate: 5.0,
      },
    ],
  },
  {
    id: 3,
    photo: "https://vetra.laborasyon.com/assets/images/products/3.jpg",
    name: "Digital Clock",
    shortDescription:
      "Lorem ipsum, dolor sit amet consectetur adipisicing elit.",
    featureDescription:
      "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Laboriosam dolor sit amet consectetur adipisicing elit., eaque. Porro dolorem asperiores eos nostrum corrupti! Sit officia distinctio quidem amet nulla",
    londDescription:
      "Lorem, ipsum dolor sit amet consectetur adipisicing elit. Maiores ad saepe porro laudantium, assumenda eos perspiciatis. Quia repellendus\n\n eligendi exercitationem explicabo consectetur facilis vitae nemo dignissimos, totam quas in nostrum optio blanditiis amet quam consequatur illum eos minus voluptates possimus aperiam non modi voluptatem velit!\n Doloremque distinctio commodi corporis adipisci voluptatem fugit maxime error officiis dicta deleniti exercitationem provident a obcaecati, quaerat dolores dolor harum non perferendis blanditiis ipsum aliquam\n\n ducimus sapiente molestias. Atque odio inventore consequuntur delectus beatae fugit. Accusamus, aut tempora cupiditate temporibus consequuntur dolorem iusto laborum nihil!",
    price: "$230.00",
    qty: 0,
    rating: 3,
    reviews: [
      {
        username: "Rodger Stutely",
        avatar_url: "https://i.pravatar.cc/150?img=69",
        review:
          "I love your products. It is very easy and fun to use this panel. I would recommend it to everyone.",
        rate: 5.0,
      },
      {
        username: "Corly Hailston",
        avatar_url: "https://i.pravatar.cc/150?img=25",
        review:
          "I love your products. It is very easy and fun to use this panel. I would recommend it to everyone.",
        rate: 5.0,
      },
      {
        username: "Hurleigh Smallcomb",
        avatar_url: "https://i.pravatar.cc/150?img=41",
        review:
          "I love your products. It is very easy and fun to use this panel. I would recommend it to everyone.",
        rate: 5.0,
      },
    ],
  },
  {
    id: 4,
    photo: "https://vetra.laborasyon.com/assets/images/products/4.jpg",
    name: "Toy Car",
    shortDescription:
      "Lorem ipsum, dolor sit amet consectetur adipisicing elit.",
    featureDescription:
      "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Laboriosam dolor sit amet consectetur adipisicing elit., eaque. Porro dolorem asperiores eos nostrum corrupti! Sit officia distinctio quidem amet nulla",
    londDescription:
      "Lorem, ipsum dolor sit amet consectetur adipisicing elit. Maiores ad saepe porro laudantium, assumenda eos perspiciatis. Quia repellendus\n\n eligendi exercitationem explicabo consectetur facilis vitae nemo dignissimos, totam quas in nostrum optio blanditiis amet quam consequatur illum eos minus voluptates possimus aperiam non modi voluptatem velit!\n Doloremque distinctio commodi corporis adipisci voluptatem fugit maxime error officiis dicta deleniti exercitationem provident a obcaecati, quaerat dolores dolor harum non perferendis blanditiis ipsum aliquam\n\n ducimus sapiente molestias. Atque odio inventore consequuntur delectus beatae fugit. Accusamus, aut tempora cupiditate temporibus consequuntur dolorem iusto laborum nihil!",
    price: "$54.00",
    qty: 12,
    rating: 4,
    reviews: [
      {
        username: "Rodger Stutely",
        avatar_url: "https://i.pravatar.cc/150?img=69",
        review:
          "I love your products. It is very easy and fun to use this panel. I would recommend it to everyone.",
        rate: 5.0,
      },
      {
        username: "Corly Hailston",
        avatar_url: "https://i.pravatar.cc/150?img=25",
        review:
          "I love your products. It is very easy and fun to use this panel. I would recommend it to everyone.",
        rate: 5.0,
      },
      {
        username: "Hurleigh Smallcomb",
        avatar_url: "https://i.pravatar.cc/150?img=41",
        review:
          "I love your products. It is very easy and fun to use this panel. I would recommend it to everyone.",
        rate: 5.0,
      },
    ],
  },
  {
    id: 5,
    photo: "https://vetra.laborasyon.com/assets/images/products/5.jpg",
    name: "Sunglasses",
    shortDescription:
      "Lorem ipsum, dolor sit amet consectetur adipisicing elit.",
    featureDescription:
      "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Laboriosam dolor sit amet consectetur adipisicing elit., eaque. Porro dolorem asperiores eos nostrum corrupti! Sit officia distinctio quidem amet nulla",
    londDescription:
      "Lorem, ipsum dolor sit amet consectetur adipisicing elit. Maiores ad saepe porro laudantium, assumenda eos perspiciatis. Quia repellendus\n\n eligendi exercitationem explicabo consectetur facilis vitae nemo dignissimos, totam quas in nostrum optio blanditiis amet quam consequatur illum eos minus voluptates possimus aperiam non modi voluptatem velit!\n Doloremque distinctio commodi corporis adipisci voluptatem fugit maxime error officiis dicta deleniti exercitationem provident a obcaecati, quaerat dolores dolor harum non perferendis blanditiis ipsum aliquam\n\n ducimus sapiente molestias. Atque odio inventore consequuntur delectus beatae fugit. Accusamus, aut tempora cupiditate temporibus consequuntur dolorem iusto laborum nihil!",
    price: "$20.00",
    qty: 340,
    rating: 4,
    reviews: [
      {
        username: "Rodger Stutely",
        avatar_url: "https://i.pravatar.cc/150?img=69",
        review:
          "I love your products. It is very easy and fun to use this panel. I would recommend it to everyone.",
        rate: 5.0,
      },
      {
        username: "Corly Hailston",
        avatar_url: "https://i.pravatar.cc/150?img=25",
        review:
          "I love your products. It is very easy and fun to use this panel. I would recommend it to everyone.",
        rate: 5.0,
      },
      {
        username: "Hurleigh Smallcomb",
        avatar_url: "https://i.pravatar.cc/150?img=41",
        review:
          "I love your products. It is very easy and fun to use this panel. I would recommend it to everyone.",
        rate: 5.0,
      },
    ],
  },
  {
    id: 6,
    photo: "https://vetra.laborasyon.com/assets/images/products/6.jpg",
    name: "Cake",
    shortDescription:
      "Lorem ipsum, dolor sit amet consectetur adipisicing elit.",
    featureDescription:
      "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Laboriosam dolor sit amet consectetur adipisicing elit., eaque. Porro dolorem asperiores eos nostrum corrupti! Sit officia distinctio quidem amet nulla",
    londDescription:
      "Lorem, ipsum dolor sit amet consectetur adipisicing elit. Maiores ad saepe porro laudantium, assumenda eos perspiciatis. Quia repellendus \n\neligendi exercitationem explicabo consectetur facilis vitae nemo dignissimos, totam quas in nostrum optio blanditiis amet quam consequatur illum eos minus voluptates possimus aperiam non modi voluptatem velit! \nDoloremque distinctio commodi corporis adipisci voluptatem fugit maxime error officiis dicta deleniti exercitationem provident a obcaecati, quaerat dolores dolor harum non perferendis blanditiis ipsum aliquam \n\nducimus sapiente molestias. Atque odio inventore consequuntur delectus beatae fugit. Accusamus, aut tempora cupiditate temporibus consequuntur dolorem iusto laborum nihil!",
    price: "$69.00",
    qty: 0,
    rating: 4,
    reviews: [
      {
        username: "Rodger Stutely",
        avatar_url: "https://i.pravatar.cc/150?img=69",
        review:
          "I love your products. It is very easy and fun to use this panel. I would recommend it to everyone.",
        rate: 5.0,
      },
      {
        username: "Corly Hailston",
        avatar_url: "https://i.pravatar.cc/150?img=25",
        review:
          "I love your products. It is very easy and fun to use this panel. I would recommend it to everyone.",
        rate: 5.0,
      },
      {
        username: "Hurleigh Smallcomb",
        avatar_url: "https://i.pravatar.cc/150?img=41",
        review:
          "I love your products. It is very easy and fun to use this panel. I would recommend it to everyone.",
        rate: 5.0,
      },
    ],
  },
  {
    id: 7,
    photo: "https://vetra.laborasyon.com/assets/images/products/7.jpg",
    name: "Glass",
    shortDescription:
      "Lorem ipsum, dolor sit amet consectetur adipisicing elit.",
    featureDescription:
      "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Laboriosam dolor sit amet consectetur adipisicing elit., eaque. Porro dolorem asperiores eos nostrum corrupti! Sit officia distinctio quidem amet nulla",
    londDescription:
      "Lorem, ipsum dolor sit amet consectetur adipisicing elit. Maiores ad saepe porro laudantium, assumenda eos perspiciatis. Quia repellendus\n\n eligendi exercitationem explicabo consectetur facilis vitae nemo dignissimos, totam quas in nostrum optio blanditiis amet quam consequatur illum eos minus voluptates possimus aperiam non modi voluptatem velit!\n Doloremque distinctio commodi corporis adipisci voluptatem fugit maxime error officiis dicta deleniti exercitationem provident a obcaecati, quaerat dolores dolor harum non perferendis blanditiis ipsum aliquam\n\n ducimus sapiente molestias. Atque odio inventore consequuntur delectus beatae fugit. Accusamus, aut tempora cupiditate temporibus consequuntur dolorem iusto laborum nihil!",
    price: "$34.00",
    qty: 12,
    rating: 5,
    reviews: [
      {
        username: "Rodger Stutely",
        avatar_url: "https://i.pravatar.cc/150?img=69",
        review:
          "I love your products. It is very easy and fun to use this panel. I would recommend it to everyone.",
        rate: 5.0,
      },
      {
        username: "Corly Hailston",
        avatar_url: "https://i.pravatar.cc/150?img=25",
        review:
          "I love your products. It is very easy and fun to use this panel. I would recommend it to everyone.",
        rate: 5.0,
      },
      {
        username: "Hurleigh Smallcomb",
        avatar_url: "https://i.pravatar.cc/150?img=41",
        review:
          "I love your products. It is very easy and fun to use this panel. I would recommend it to everyone.",
        rate: 5.0,
      },
    ],
  },
  {
    id: 8,
    photo: "https://vetra.laborasyon.com/assets/images/products/8.jpg",
    name: "Ear Buds",
    shortDescription:
      "Lorem ipsum, dolor sit amet consectetur adipisicing elit.",
    featureDescription:
      "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Laboriosam dolor sit amet consectetur adipisicing elit., eaque. Porro dolorem asperiores eos nostrum corrupti! Sit officia distinctio quidem amet nulla",
    londDescription:
      "Lorem, ipsum dolor sit amet consectetur adipisicing elit. Maiores ad saepe porro laudantium, assumenda eos perspiciatis. Quia repellendus\n\n eligendi exercitationem explicabo consectetur facilis vitae nemo dignissimos, totam quas in nostrum optio blanditiis amet quam consequatur illum eos minus voluptates possimus aperiam non modi voluptatem velit!\n Doloremque distinctio commodi corporis adipisci voluptatem fugit maxime error officiis dicta deleniti exercitationem provident a obcaecati, quaerat dolores dolor harum non perferendis blanditiis ipsum aliquam\n\n ducimus sapiente molestias. Atque odio inventore consequuntur delectus beatae fugit. Accusamus, aut tempora cupiditate temporibus consequuntur dolorem iusto laborum nihil!",
    price: "$100.00",
    qty: 0,
    rating: 5,
    reviews: [
      {
        username: "Rodger Stutely",
        avatar_url: "https://i.pravatar.cc/150?img=69",
        review:
          "I love your products. It is very easy and fun to use this panel. I would recommend it to everyone.",
        rate: 5.0,
      },
      {
        username: "Corly Hailston",
        avatar_url: "https://i.pravatar.cc/150?img=25",
        review:
          "I love your products. It is very easy and fun to use this panel. I would recommend it to everyone.",
        rate: 5.0,
      },
      {
        username: "Hurleigh Smallcomb",
        avatar_url: "https://i.pravatar.cc/150?img=41",
        review:
          "I love your products. It is very easy and fun to use this panel. I would recommend it to everyone.",
        rate: 5.0,
      },
    ],
  },
  {
    id: 9,
    photo: "https://vetra.laborasyon.com/assets/images/products/9.jpg",
    name: "Perfume",
    shortDescription:
      "Lorem ipsum, dolor sit amet consectetur adipisicing elit.",
    featureDescription:
      "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Laboriosam dolor sit amet consectetur adipisicing elit., eaque. Porro dolorem asperiores eos nostrum corrupti! Sit officia distinctio quidem amet nulla",
    londDescription:
      "Lorem, ipsum dolor sit amet consectetur adipisicing elit. Maiores ad saepe porro laudantium, assumenda eos perspiciatis. Quia repellendus\n\n eligendi exercitationem explicabo consectetur facilis vitae nemo dignissimos, totam quas in nostrum optio blanditiis amet quam consequatur illum eos minus voluptates possimus aperiam non modi voluptatem velit!\n Doloremque distinctio commodi corporis adipisci voluptatem fugit maxime error officiis dicta deleniti exercitationem provident a obcaecati, quaerat dolores dolor harum non perferendis blanditiis ipsum aliquam\n\n ducimus sapiente molestias. Atque odio inventore consequuntur delectus beatae fugit. Accusamus, aut tempora cupiditate temporibus consequuntur dolorem iusto laborum nihil!",
    price: "$90.00",
    qty: 34,
    rating: 5,
    reviews: [
      {
        username: "Rodger Stutely",
        avatar_url: "https://i.pravatar.cc/150?img=69",
        review:
          "I love your products. It is very easy and fun to use this panel. I would recommend it to everyone.",
        rate: 5.0,
      },
      {
        username: "Corly Hailston",
        avatar_url: "https://i.pravatar.cc/150?img=25",
        review:
          "I love your products. It is very easy and fun to use this panel. I would recommend it to everyone.",
        rate: 5.0,
      },
      {
        username: "Hurleigh Smallcomb",
        avatar_url: "https://i.pravatar.cc/150?img=41",
        review:
          "I love your products. It is very easy and fun to use this panel. I would recommend it to everyone.",
        rate: 5.0,
      },
    ],
  },
  {
    id: 10,
    photo: "https://vetra.laborasyon.com/assets/images/products/10.jpg",
    name: "Cookie",
    shortDescription:
      "Lorem ipsum, dolor sit amet consectetur adipisicing elit.",
    featureDescription:
      "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Laboriosam dolor sit amet consectetur adipisicing elit., eaque. Porro dolorem asperiores eos nostrum corrupti! Sit officia distinctio quidem amet nulla",
    londDescription:
      "Lorem, ipsum dolor sit amet consectetur adipisicing elit. Maiores ad saepe porro laudantium, assumenda eos perspiciatis. Quia repellendus\n\n eligendi exercitationem explicabo consectetur facilis vitae nemo dignissimos, totam quas in nostrum optio blanditiis amet quam consequatur illum eos minus voluptates possimus aperiam non modi voluptatem velit!\n Doloremque distinctio commodi corporis adipisci voluptatem fugit maxime error officiis dicta deleniti exercitationem provident a obcaecati, quaerat dolores dolor harum non perferendis blanditiis ipsum aliquam\n\n ducimus sapiente molestias. Atque odio inventore consequuntur delectus beatae fugit. Accusamus, aut tempora cupiditate temporibus consequuntur dolorem iusto laborum nihil!",
    price: "$10.00",
    qty: 0,
    rating: 3,
    reviews: [
      {
        username: "Rodger Stutely",
        avatar_url: "https://i.pravatar.cc/150?img=69",
        review:
          "I love your products. It is very easy and fun to use this panel. I would recommend it to everyone.",
        rate: 5.0,
      },
      {
        username: "Corly Hailston",
        avatar_url: "https://i.pravatar.cc/150?img=25",
        review:
          "I love your products. It is very easy and fun to use this panel. I would recommend it to everyone.",
        rate: 5.0,
      },
      {
        username: "Hurleigh Smallcomb",
        avatar_url: "https://i.pravatar.cc/150?img=41",
        review:
          "I love your products. It is very easy and fun to use this panel. I would recommend it to everyone.",
        rate: 5.0,
      },
    ],
  },
];
